const MIGRATION_KEY = '__migration__';

export function createMigrationKey(collection: string): string {
  return `${MIGRATION_KEY}-${collection}`;
}
